import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';

import { environment } from '../../../environments/environment';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';

import jwt_decode from "jwt-decode";
import { RolesAccessClaimsModel } from 'src/app/model/roleAccessModel';
import { map } from 'rxjs/operators';
import { Location } from '@angular/common'

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    roleAccess: any[];

    constructor(
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var token = sessionStorage.getItem("tokenInfo");
        var data = route.data["claims"];
        if (data && token) {
            if (!this.hasClaimsAuthGuard(data)) {
                this.router.navigate(['/pages/403']);
            }
        }
        if (token) {
            return true;
        }
        this.router.navigate(['/account/login']);
        return false;
    }

    getRoleAccess() {
        this.roleAccess = JSON.parse(sessionStorage.getItem("roleAccess"))["ClaimsAction"];
    }


    hasClaimsSingle(claimsAction): boolean {
        this.getRoleAccess();
        var project = claimsAction["project"];
        var module = claimsAction["module"];
        var action = claimsAction["action"];

        var role = this.roleAccess.filter(c => c.Project === project)
        if (role.length === 0) { return false; }
        role = role.filter(c => c.Module === module)
        if (role.length === 0) { return false; }
        role = role.filter(c => c.Action === action);
        if (role.length === 0) { return false; }

        return true;
    }

    hasClaimsAuthGuard(claimsAction): boolean {
        this.getRoleAccess();
        var project = claimsAction.map(({ project }) => project);
        var module = claimsAction.map(({ module }) => module);
        var action = claimsAction.map(({ action }) => action);

        var role = this.roleAccess.filter(c => project.includes(c.Project))
        if (role.length === 0) { return false; }
        role = role.filter(c => module.includes(c.Module))
        if (role.length === 0) { return false; }
        role = role.filter(c => action.includes(c.Action));
        if (role.length === 0) { return false; }

        return true;
    }

    hasClaims(menu: Array<MenuItem>) {
        this.getRoleAccess();
        menu.forEach(menuT => {
            if (!menuT.roleAccess) { menuT.showMenu = false; return; }

            var project = menuT.roleAccess.map(({ project }) => project);
            var module = menuT.roleAccess.map(({ module }) => module);
            var action = menuT.roleAccess.map(({ action }) => action);
            menuT.showMenu = true;

            var role = this.roleAccess.filter(c => project.includes(c.Project))
            if (role.length === 0) { menuT.showMenu = false; return; }
            role = role.filter(c => module.includes(c.Module))
            if (role.length === 0) { menuT.showMenu = false; return; }
            role = role.filter(c => action.includes(c.Action));
            if (role.length === 0) { menuT.showMenu = false; return; }
            if (menuT.subItems?.length > 0) {
                menuT.subItems = this.checkSubItems(menuT.subItems);
            }
        })
        menu = menu.filter(c => c.showMenu)
    }
    checkSubItems(subItems) {
        subItems.forEach(menuT => {
            if (!menuT.roleAccess) { menuT.showMenu = false; return; }

            var project = menuT.roleAccess.map(({ project }) => project);
            var module = menuT.roleAccess.map(({ module }) => module);
            var action = menuT.roleAccess.map(({ action }) => action);
            menuT.showMenu = true;

            var role = this.roleAccess.filter(c => project.includes(c.Project))
            if (role.length === 0) { menuT.showMenu = false; return; }
            role = role.filter(c => module.includes(c.Module))
            if (role.length === 0) { menuT.showMenu = false; return; }
            role = role.filter(c => action.includes(c.Action));
            if (role.length === 0) { menuT.showMenu = false; return; }

            if (menuT.subItems?.length > 0) {
                menuT.subItems = this.checkSubItems(menuT.subItems);
            }
        })
        return subItems;
    }
}